var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapsecheck2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3201 16.8267C13.4001 16.9067 13.5334 16.9067 13.6134 16.8267L15.8668 14.5734L22.6668 7.77335C22.7468 7.69335 22.7468 7.56002 22.6668 7.48002L20.5601 5.37335C20.4801 5.29335 20.3468 5.29335 20.2668 5.37335L13.4668 12.1734L10.9068 9.61335C10.8268 9.53335 10.6934 9.53335 10.6134 9.61335L8.50678 11.72C8.42678 11.8 8.42678 11.9334 8.50678 12.0134L11.0668 14.5734L13.3201 16.8267Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4668 19.9867L9.73344 16.2533C9.65344 16.1733 9.5201 16.1733 9.4401 16.2533L7.33344 18.36C7.25344 18.44 7.25344 18.5733 7.33344 18.6533L11.0668 22.3867L13.3201 24.64C13.4001 24.72 13.5334 24.72 13.6134 24.64L15.8668 22.3867L21.9068 16.3467C21.9868 16.2667 21.9868 16.1333 21.9068 16.0533L19.8001 13.9467C19.7201 13.8667 19.5868 13.8667 19.5068 13.9467L13.4668 19.9867Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsecheck2);
export default __webpack_public_path__ + "static/media/Collapsecheck2.d22622cb1b3478f946b58b2ac4734212.svg";
export { ForwardRef as ReactComponent };